"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextBlock = TextBlock;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledTextBlock = _interopRequireDefault(require("./styled-text-block"));
var _excluded = ["children", "dataTestId", "background"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var propTypes = {
  background: _propTypes["default"].string,
  blackBorder: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired,
  dataTestId: _propTypes["default"].string,
  paddingBottom: _propTypes["default"].bool,
  paddingLeft: _propTypes["default"].bool,
  paddingRight: _propTypes["default"].bool,
  paddingTop: _propTypes["default"].bool
};
var defaultProps = {
  background: undefined,
  blackBorder: false,
  dataTestId: null,
  paddingBottom: true,
  paddingLeft: true,
  paddingRight: true,
  paddingTop: true
};
function TextBlock(_ref) {
  var children = _ref.children,
    dataTestId = _ref.dataTestId,
    background = _ref.background,
    props = _objectWithoutProperties(_ref, _excluded);
  var textBlockRef = _react["default"].useRef();
  _react["default"].useEffect(function () {
    textBlockRef.current.querySelectorAll('h1, h2, h3, h4, h5, h6, p').forEach(function (el) {
      if (el.children.length > 0) {
        if (el.children[0].classList.toString().indexOf('fuse-text-block__text-size') > -1) {
          el.classList.add('fuse-text-block__custom-text-size');
        } else if (el.children[0].children.length > 0 && el.children[0].children[0].classList.toString().indexOf('fuse-text-block__text-size') > -1) {
          el.classList.add('fuse-text-block__custom-text-size');
        }
      }
    });
    textBlockRef.current.querySelectorAll('ul').forEach(function (ul) {
      var listTypes = [{
        selector: '.fuse-text-block__unordered-list',
        className: 'fuse-text-block__unordered-list--brand-mid'
      }, {
        selector: '.fuse-text-block__unordered-ticklist',
        className: 'fuse-text-block__unordered-ticklist--tick',
        spanContent: 'Tick Icon'
      }, {
        selector: '.fuse-text-block__unordered-crosslist',
        className: 'fuse-text-block__unordered-crosslist--cross',
        spanContent: 'Cross Icon'
      }];
      listTypes.forEach(function (_ref2) {
        var selector = _ref2.selector,
          className = _ref2.className,
          spanContent = _ref2.spanContent;
        if (ul.querySelector(selector)) {
          ul.classList.add(className);
          if (!background) {
            ul.querySelectorAll(':scope > li').forEach(function (li) {
              if (spanContent) {
                li.insertAdjacentHTML('afterbegin', "<span class=\"visually-hidden\">".concat(spanContent, "</span>"));
              }
            });
          }
        }
      });
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_styledTextBlock["default"], _extends({
    className: "fuse-text-block",
    "data-testid": dataTestId,
    background: background,
    ref: textBlockRef
  }, props), children);
}
TextBlock.propTypes = propTypes;
TextBlock.defaultProps = defaultProps;
var _default = exports["default"] = TextBlock;